import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-part3',
  templateUrl: './part3.component.html',
  styleUrls: ['./part3.component.scss']
})
export class Part3Component implements OnInit {

  readonly baseURL = './assets/images/part3/';

  readonly frameContents = [
    {
      imgUrl: 'img0.png',
      lable: ['לוח המשחק',
        'תצוגת השחקנים המהירים',
        'צבירת נקודות אישית',
        'אפשרויות עניית התשובה',
        'הצבעה בזמן אמת',
        'הנחיה בשידור חי מאולפן מקצועי'
      ]
    }, {
      imgUrl: 'img1.png',
      lable: ['הצטרפות לקבוצות']
    }, {
      imgUrl: 'img2.png',
      lable: ['שידור מאולפן מקצועי']
    }, {
      imgUrl: 'img3.png',
      lable: ['שאלה פתוחה להצבעה']
    }, {
      imgUrl: 'img4.png',
      lable: ['תוצאות השאלה והתשובות']
    }, {
      imgUrl: 'img5.png',
      lable: ['מסכי מובילים במשחק']
    }, {
      imgUrl: 'img6.png',
      lable: ['הקבוצה המובילה במשחק']
    }, {
      imgUrl: 'img7.png',
      lable: ['תתי קבוצות מובילות']
    }, {
      imgUrl: 'img8.png',
      lable: ['המובילים בקבוצות המשחק']
    }, {
      imgUrl: 'img9.png',
      lable: ['המובילים בחלוקה לתתי קבוצות']
    }, {
      imgUrl: 'img10.png',
      lable: ['הקבוצות המנצחות']
    }, {
      imgUrl: 'img11.png',
      lable: ['תתי קבוצות מנצחות']
    }, {
      imgUrl: 'img12.png',
      lable: ['מנצחים במשחק']
    }, {
      imgUrl: 'img13.png',
      lable: ['משחק משותף, מרחוק']
    }
  ];

  currentFrameContents = 0;

  constructor() { }

  ngOnInit(): void {
  }

  scrollToById(id: string) {
    document
      .getElementById(id)
      .scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      } as ScrollIntoViewOptions);
  }

}
